export default __webpack_public_path__ + "static/media/disposition-upload-template.a93e33b0.xlsx";